const data = [
  {
    home_page: {
      title:
        "Industrial Automation, Software Development & Digital Marketing | IT Training and Services in Erode",
      meta: {
        meta1: {
          name: "description",
          content:
            "Leading industrial automation, Embedded Systems, software development, and digital marketing Training and Services in Erode, offering PLC, SCADA, robotics, AI solutions, SEO, and branding services.",
        },
      },
    },

    our_course: {
      title:
        "Industrial Automation, AI & Digital Marketing Course in Erode | Certification Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join industry-oriented training in Industrial Automation, IIoT, Software Development, and Digital Marketing in Erode with practical projects and certification.",
        },
      },
    },

    industrial_automation_page: {
      title:
        "Industrial Automation, AI & Digital Marketing Course in Erode | Certification Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join industry-oriented training in Industrial Automation, IIoT, Software Development, and Digital Marketing in Erode with practical projects and certification.",
        },
      },
    },

    digitalmarketing_page: {
      title:
        "Industrial Automation, AI & Digital Marketing Course in Erode | Certification Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join industry-oriented training in Industrial Automation, IIoT, Software Development, and Digital Marketing in Erode with practical projects and certification.",
        },
      },
    },

    embedded_systems_page: {
      title:
        "Industrial Automation, AI & Digital Marketing Course in Erode | Certification Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join industry-oriented training in Industrial Automation, IIoT, Software Development, and Digital Marketing in Erode with practical projects and certification.",
        },
      },
    },

    information_technology_page: {
      title:
        "Industrial Automation, AI & Digital Marketing Course in Erode | Certification Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join industry-oriented training in Industrial Automation, IIoT, Software Development, and Digital Marketing in Erode with practical projects and certification.",
        },
      },
    },

    Internship_page: {
      title:
        "Industrial Automation, AI & Digital Marketing Course in Erode | Certification Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join industry-oriented training in Industrial Automation, IIoT, Software Development, and Digital Marketing in Erode with practical projects and certification.",
        },
      },
    },

    workshop_page: {
      title:
        "Industrial Automation, AI & Digital Marketing Course in Erode | Certification Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join industry-oriented training in Industrial Automation, IIoT, Software Development, and Digital Marketing in Erode with practical projects and certification.",
        },
      },
    },

    seminar_page: {
      title:
        "Industrial Automation, AI & Digital Marketing Course in Erode | Certification Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join industry-oriented training in Industrial Automation, IIoT, Software Development, and Digital Marketing in Erode with practical projects and certification.",
        },
      },
    },

    corporate_training_page: {
      title:
        "Industrial Automation, AI & Digital Marketing Course in Erode | Certification Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join industry-oriented training in Industrial Automation, IIoT, Software Development, and Digital Marketing in Erode with practical projects and certification.",
        },
      },
    },

    about_page: {
      title:
        "About Us | Industrial Automation, Software & Digital Marketing | Training and Placement Support in Erode",
      meta: {
        meta1: {
          name: "description",
          content:
            "Learn about our expertise in industrial automation, IIoT, software development, and digital marketing. Training and Placement Support in Erode, delivering innovative technology solutions.",
        },
      },
    },

    service_page: {
      title:
        "Services | Industrial Automation, PLC SCADA, Embedded Systems, Software & Digital Marketing Services in Erode",
      meta: {
        meta1: {
          name: "description",
          content:
            "Discover our expert services in industrial automation, PLC SCADA, Embedded Systems, and IIoT, software development, AI solutions, and digital marketing services in Erode.",
        },
      },
    },

    career_page: {
      title:
        "Industrial Automation, Software Development & Digital Marketing | IT Training and Services in Erode",
      meta: {
        meta1: {
          name: "description",
          content:
            "Explore career opportunities in industrial automation, software development, and digital marketing with training and growth support in Erode.",
        },
      },
    },

    contact_page: {
      title:
        "Contact Us | Industrial Automation, Software & Digital Marketing Training and Services in Erode",
      content:
        "Contact our Erode team for industrial automation, Embedded Systems and IIoT, software development, and digital marketing solutions. Reach out to us for consultation and project support.",
      meta: {
        meta1: {
          name: "description",
          content:
            "Contact our Erode team for industrial automation, Embedded Systems and IIoT, software development, and digital marketing solutions. Reach out to us for consultation and project support.",
        },
      },
    },

    cookieContent:
      "We use cookies to personalize content, analyze traffic, and improve user experience. By continuing, you agree to our cookie usage.",
  },
];

export default data;